<!-- loading组件 -->
<template>
    <div class="loading">
        <van-overlay :show="show" :z-index="2100">
            <div class="loading-container">
                <van-loading type="spinner" vertical>{{ text }}</van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: "加载中",
        },
    },
    data() {
        return {};
    },

    mounted() {},

    methods: {
        hide() {
            this.show = false;
        },
    },
};
</script>
<style lang="less" scoped>
.loading {
    z-index: 2100;

    .loading-container {
        width: 200px;
        min-height: 100px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;
    }
}
</style>
